const React = require('react');
const connect = require('react-redux/dist/react-redux.min.js').connect;
const ReduxStore = require('./redux/reduxStore.jsx.js');
const SharedConstants = require('../../../shared/sharedConstants');
const IncubatorList = require('./components/incubatorList.jsx').IncubatorList;
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Button from '@material-ui/core/Button';
import Grid from "@material-ui/core/Grid";
const moment = require('moment');


export class IncubatorListPage extends React.Component{
   constructor(props) {
      super(props);
      this.state={
         newPortfolioName: '',
         showDeleteModal: false,
         portfolioToDelete: null,
         currentTab: 0
      }
   }
   
   render() {
      return (
         <div id='portfolioListMainContainer' className={'page-container'}>
            <div className='portfolio-list-page-header'>
            <h1>Engage with Workshops</h1>
            </div>
            {window.globals.isSponsor && 
               <Button variant='outlined' color="primary" href="/sponsor/createPortfolio">Create Workshop</Button>

            }
               <Tabs className='portfolio-list-page-tab-header' value={this.state.currentTab} indicatorColor={'primary'} onChange={(e, v) => this.setState({ currentTab: v })}>
                  <Tab className='portfolio-list-page-tab' label="PUBLIC WORKSHOPS" style={{ color: this.state.currentTab === 0 ? '#4357CF' : 'gray' }} />
                 {window.globals.idUser &&  <Tab className='portfolio-list-page-tab' label="PRIVATE WORKSHOPS" style={{ color: this.state.currentTab === 1 ? '#4357CF' : 'gray' }} />}
                 {window.globals.idUser &&  <Tab className='portfolio-list-page-tab' label="YOUR WORKSHOPS" style={{ color: this.state.currentTab === 2 ? '#4357CF' : 'gray' }} />}

               </Tabs>
               <br/>
               <Grid container alignItems="stretch" spacing={2}>
              {(this.state.currentTab == 0) && 
              <OpenSponsoredPortfolioListItems type='active'/> 
              }
               {(this.state.currentTab == 0) &&     
               <ClosedSponsoredPortfolioListItems type='disabled'/> 
               }
               {(this.state.currentTab == 1) &&     
                  <OpenPrivateSponsoredPortfolioListItems type='active'/>
               }
               {(this.state.currentTab == 1) &&     
                  <ClosedPrivateSponsoredPortfolioListItems type='disabled'/>
               }
               {(this.state.currentTab == 2) &&
                  <OwnedPortfolioListItems type='owned'/>
               }
            </Grid>
         </div>
      );
   }
}



const openSponsoredPortfolioListItemsStateToProps = (state) => {
   let curDate = new Date();
   return {
      portfolioList: state.PortfolioReducer.portfolioList.sponsored.filter(x => {
         let incubatorIsActive = moment(curDate).isSameOrBefore(x.incubatorEndTime ? x.incubatorEndTime: x.proposalDueTime, 'day');
         return(x.privacyType === SharedConstants.PortfolioType.Sponsored && incubatorIsActive)
      }
      ).sort(
         (a, b) => b.id - a.id
      ),
      isLoaded: state.PortfolioReducer.isLoaded,
   }
};


const closedSponsoredPortfolioListItemsStateToProps = (state) => {
   let curDate = new Date();
   return {
      portfolioList: state.PortfolioReducer.portfolioList.sponsored.filter(x => {
         let incubatorIsActive = moment(curDate).isSameOrBefore(x.incubatorEndTime ? x.incubatorEndTime: x.proposalDueTime, 'day');
         return(x.privacyType === SharedConstants.PortfolioType.Sponsored && !incubatorIsActive)
      }
      ).sort(
         (a, b) => b.id - a.id
      ),
      isLoaded: state.PortfolioReducer.isLoaded,
   }
};

const openPrivatePortfolioListItemsStateToProps = (state) => {
   let curDate = new Date();
   return {
      portfolioList: state.PortfolioReducer.portfolioList.sponsored.filter(x =>
         x.privacyType === SharedConstants.PortfolioType.SponsoredPrivate && (new Date(x.incubatorEndTime ? x.incubatorEndTime: x.proposalDueTime) >= curDate)
      ).sort(
         (a, b) => b.id - a.id
      ),
      isLoaded: state.PortfolioReducer.isLoaded,
   }
};

const closedPrivatePortfolioListItemsStateToProps = (state) => {
   let curDate = new Date();
   return {
      portfolioList: state.PortfolioReducer.portfolioList.sponsored.filter(x =>
         x.privacyType === SharedConstants.PortfolioType.SponsoredPrivate &&  (new Date(x.incubatorEndTime ? x.incubatorEndTime: x.proposalDueTime) < curDate)
      ).sort(
         (a, b) => b.id - a.id
      ),
      isLoaded: state.PortfolioReducer.isLoaded,
   }
};

const ownedPortfolioListItemsStateToProps = (state) => {
   return {
      portfolioList: state.PortfolioReducer.portfolioList.owned.filter(x =>
         x.privacyType === SharedConstants.PortfolioType.Sponsored ||
         x.privacyType === SharedConstants.PortfolioType.SponsoredPrivate
      ).sort(
         (a, b) => b.id - a.id
      ),
      isLoaded: state.PortfolioReducer.isLoaded,
   }
};

const portfolioListItemsDispatchToProps = (dispatch) => {
   return {
      cardLinkFunction: (cardData) => {
         if(cardData.cardType === SharedConstants.CardType.Evidence)
            dispatch(ReduxStore.EvidenceCardFunctions.setCurrentCard(cardData));
         else if(cardData.cardType === SharedConstants.CardType.Reasoning)
            dispatch(ReduxStore.GreySpaceCardFunctions.setCurrentCard(cardData));

      },
   }
};

const OpenSponsoredPortfolioListItems = connect(
   openSponsoredPortfolioListItemsStateToProps,
   portfolioListItemsDispatchToProps
)(IncubatorList);

const ClosedSponsoredPortfolioListItems = connect(
   closedSponsoredPortfolioListItemsStateToProps,
   portfolioListItemsDispatchToProps
)(IncubatorList);

const OwnedPortfolioListItems = connect(
   ownedPortfolioListItemsStateToProps,
   portfolioListItemsDispatchToProps
)(IncubatorList);

const OpenPrivateSponsoredPortfolioListItems = connect(
   openPrivatePortfolioListItemsStateToProps,
   portfolioListItemsDispatchToProps
)(IncubatorList);

const ClosedPrivateSponsoredPortfolioListItems = connect(
   closedPrivatePortfolioListItemsStateToProps,
   portfolioListItemsDispatchToProps
)(IncubatorList);